import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isSelected } from "ducks/catalog/selectors";
import { selectResource, unselectResource } from "ducks/catalog/catalog";
import { ResourceInfoDc } from "../types";

export const useSelectedResource = (resource: ResourceInfoDc): [boolean, VoidFunction] => {
  const resourceSelected = useSelector(isSelected(resource.name));
  const dispatch = useDispatch();

  const toggleSelected = useCallback(() => {
    if (resourceSelected) {
      dispatch(unselectResource({ resourceName: resource.name }));
    } else {
      dispatch(selectResource({ resource }));
    }
  }, [resource, resourceSelected, dispatch]);

  return [resourceSelected, toggleSelected];
};
